import { useQueryClient } from '@tanstack/react-query'
import axios from '@/shared/api/axios'
import { FEATURES } from '@/shared/config/features'
import { API } from '@/shared/constants/api'
import { removeLocalStorage } from '@/shared/utils/localstorage'
import useAuth from './use-auth'

const useLogout = () => {
  const { logoutV2Session, setAuth } = useAuth()
  const queryClient = useQueryClient()

  const logout = async () => {
    removeLocalStorage('auth')
    queryClient.clear()

    if (FEATURES.webAuthV2) {
      await logoutV2Session()
      return
    }

    setAuth(null)

    try {
      await axios.get(API.auth.logout, {
        withCredentials: true
      })
    } catch (error) {
      console.error(error)
    }
  }

  return logout
}

export default useLogout
